<template>
    <div :class="isServiceRoute ? 'rootServices' : 'servicesInChat'">
        <vs-table 
            ref="table" 
            :data="services"
            :id="isServiceRoute ? 'tableDataRoot' : 'tableDataOfServicesInChat'"
            @search="searchFilter"
            @sort="sortFilter"
            :sst="true"
            noDataText="Sem dados disponíveis"
            search
            style="padding-right: 10px !important;"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center pl-4" v-if="isServiceRoute">
                    <div
                    class="
                        p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center
                        text-lg font-medium text-base text-primary border border-solid border-primary
                    "
                    @click="openSidebar(context='create')"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">
                            Adicionar Novo
                        </span>
                    </div>
                </div>

                <div>
                    <vs-dropdown
                            vs-trigger-click
                            class="cursor-pointer mr-4"
                        >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">                                
                                {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                                {{
                                    services.length - currentPage * itemsPerPage > 0
                                        ? currentPage * itemsPerPage
                                        : services.length
                                }} de {{ queriedItems }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>

            <template slot="thead">

                <vs-th class="text-base" v-if="!isServiceRoute">
                    <vs-checkbox 
                        @click.stop="selectAllServices()" 
                        @touchstart.stop="selectAllServices()" 
                        :value="allServicesAreSelected"
                        class="pl-4"
                    />
                </vs-th>
                <vs-th class="text-base" sort-key="name" :style="'width:' + isServiceRoute ? '250px;' : '100px;' ">
                    Nome
                </vs-th>
                <vs-th class="text-base" sort-key="price" style="width: 150px;">
                    Preço
                </vs-th>
                <vs-th class="text-base" sort-key="category">
                    Categoria
                </vs-th>
                <vs-th class="text-base" sort-key="description">
                    Descrição
                </vs-th>
                <vs-th class="text-base" sort-key="recurrence">
                    Recorrência
                </vs-th>
                <vs-th class="text-base" v-if="isServiceRoute">
                    Ações
                </vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                        :data="tr" 
                        :key="tr.id"
                        :id="tr.id"
                        v-for="(tr, index) in data"
                        ref="trService"
                        :class="tr.selected ? 'is-selected' : 'selected'"
                    >

                        <vs-td v-if="!isServiceRoute" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                            <vs-checkbox :value="tr.selected"/>
                        </vs-td>

                        <vs-td :data="tr.name">
                            <p class="ml-4 service-name" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                                {{ tr.name }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.price" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                            <p class="ml-4">
                                R$ {{ String(parseFloat(tr.price).toFixed(2)).replace('.', ',') }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.category" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                            <p class="ml-4">
                                {{ tr.category === null || tr.category === '' ? 'Nenhuma' : tr.category }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.description" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                            <p class="truncate-text ml-4">
                                {{ tr.description === null || tr.description === '' ? 'Nenhuma' : tr.description }}
                            </p>
                        </vs-td>

                        <vs-td :data="tr.recurrence" @click.native="selectService(tr)" @touchstart.native="selectService(tr)">
                            <p class="ml-4">
                                {{ tr.recurrence }}
                            </p>
                        </vs-td>

                        <vs-td v-if="isServiceRoute">
                            <div class="ml-4">
                                <feather-icon
                                    icon="EditIcon"
                                    svgClasses="h-5 hover:text-primary stroke-current"
                                    @click="openSidebar(context='update', data=tr)"
                                />
                
                                <feather-icon
                                    icon="TrashIcon"
                                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-2"
                                    @click="openDeleteModal(tr)"
                                />
                            </div>
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <div>
            <vs-sidebar
                click-not-close
                position-right
                default-index="1"
                color="primary"
                class="sidebar-services add-new-data-sidebar items-no-padding"
                spacer
                parent="body"
                v-model="sidebarIsActive"
            >

                <div class="mt-6 mb-4 flex items-center justify-between px-6">
                    <h4 v-if="sidebarData.id === undefined">ADICIONAR NOVO SERVIÇO</h4>
                    <h4 v-else>ATUALIZAR SERVIÇO</h4>
                    <feather-icon
                        icon="XIcon"
                        class="cursor-pointer"
                        @click="sidebarIsActive=false"
                    />
                </div>
                <vs-divider class="mb-0"/>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="Nome do Serviço"
                    class="mt-3 ml-8 w-5/6"
                    name="nome"
                    v-model="sidebarData.name"
                    v-validate="'required'"
                    />
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('nome')"
                >
                    {{ errors.first('nome') }}
                </span>

                <div>
                    <vs-input
                    id="input-adjustment"
                    type="number"
                    label="Preço"
                    class="mt-3 ml-8 w-5/6"
                    name="preço"
                    v-validate="'required'"
                    v-model="sidebarData.price"
                    />
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('preço')"
                >
                    {{ errors.first('preço') }}
                </span>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="Categoria"
                    class="mt-3 ml-8 w-5/6"
                    name="categoria"
                    v-model="sidebarData.category"
                    />
                </div>

                <div>
                    <vs-textarea
                    id="input-adjustment"
                    label="Descrição"
                    class="mt-3 ml-8 w-5/6"
                    name="descrição"
                    v-model="sidebarData.description"
                    />
                </div>

                <div>
                    <vs-input
                    id="input-adjustment"
                    label="Recorrência do Serviço"
                    class="mt-3 ml-8 w-5/6"
                    name="recorrência"
                    v-model="sidebarData.recurrence"
                    v-validate="'required'"
                    placeholder="Diária, mensal, semanal ou anual"
                    />
                </div>
                <span
                    class="text-danger text-sm ml-10"
                    v-show="errors.has('recorrência')"
                >
                    {{ errors.first('recorrência') }}
                </span>

                <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
                    <vs-button class="mr-6" @click="chooseContext()">
                      Salvar
                    </vs-button>
                    <vs-button type="border" color="danger" @click="sidebarIsActive=false">
                      Cancelar
                    </vs-button>
                </div>
            </vs-sidebar>
        </div>

        <div>
            <vs-popup title="Remover Serviço" :active.sync="deleteModalIsActive" @close="closeDeleteModal">
                <p class="text-center">Deseja realmente remover o Serviço de nome <strong> {{deleteData.name}} </strong>?
                </p> <br>

                <div class="w-full d-flex justify-content-flex-end">
                    <vs-button color="danger" @click.stop="deleteService">Remover</vs-button>
                </div>
            </vs-popup>
        </div>

        <div class="mt-3 mr-4">
            <vs-pagination
                :total="totalPages"
                v-model="page"
            />
        </div>

    </div>
</template>

<script>

import moduleService from '@/store/service/moduleService';

export default {
    name: 'Services',
    data() {
        return {
            search: "",
            page: 1,
            itemsPerPage: 4,
            isMounted: false,
            orderBy: {
                name: 'id',
                type: 'ASC'
            },
            sidebarData: {
                id: undefined,
                name: '',
                price: 0.0,
                category: '',
                description: '',
                recurrence: ''
            },
            sidebarIsActive: false,
            context: null,
            deleteData: {
                id: undefined,
                name: undefined
            },
            deleteModalIsActive: false,
            selectedServices: [],
            allServicesAreSelected: false
        }
    },
    methods: {
        async fetch() {
            if (!moduleService.isRegistered) {
                this.$store.registerModule('service', moduleService)
                moduleService.isRegistered = true
            }

            await this.$store.dispatch("service/fetch", {
                sortName: this.orderBy.name,
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                type: this.orderBy.type,
                word: this.search
            });

            if (this.selectedServices.length > 0) {
                this.services.forEach(service => {
                    if (service.selected === undefined) {
                        service.selected = false;
                    }

                    const isSelected = this.selectedServices.some(selectedService => selectedService.id === service.id);
                    service.selected = isSelected;
                });
            }
            this.checkServicesAreSelected();
            this.$forceUpdate();
        },
        async searchFilter(searchQuery) {
            this.search = searchQuery;
            await this.fetch();

        },
        async sortFilter(sortName) {
            if (sortName !== null) {
                if (sortName !== this.orderBy.name) {
                    this.orderBy.name = sortName;
                    this.orderBy.type = 'ASC';
                } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
                    this.orderBy.type = 'DESC';
                } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
                    this.orderBy.name = 'name';
                    this.orderBy.type = 'ASC';
                }
                await this.fetch();

            }
        },
        openSidebar(context, data) {
            this.context = context;

            switch (context) {
                case 'create':
                    this.sidebarData = {
                        id: undefined,
                        name: '',
                        price: 0.0,
                        category: '',
                        description: '',
                        recurrence: ''
                    }
                    this.sidebarIsActive = true;
                    break;
                case 'update':
                    this.sidebarData = {
                        id: data.id,
                        name: data.name,
                        price: data.price || 0.0,
                        category: data.category || '',
                        description: data.description || '',
                        recurrence: data.recurrence || ''
                    }
                    this.sidebarIsActive = true;
                    break;
                default:
                    break;
            }
        },
        chooseContext() {
            if (this.context === 'update') { this.updateData() } 
            else if (this.context === 'create') { this.createData() }
        },
        async createData() {
            const data = {
                name: this.sidebarData.name,
                price: this.sidebarData.price,
                category: this.sidebarData.category || '',
                description: this.sidebarData.description || '',
                recurrence: this.sidebarData.recurrence
            }

            this.$validator.validateAll().then(async (response) =>  {
                if (!response) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Algo deu errado:',
                        text: 'Existem campos obrigatórios não preenchidos!'
                    });
                    return;
                }
                else {
                    await this.$store.dispatch("service/create", data)
                    .then((response) => {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Serviço criado com sucesso!'
                        });
                        this.closeSidebar();
                        this.fetch();
                    })
                    .catch((exception) => {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao criar o serviço!',
                            text: 'Erro ao criar o serviço, por favor nos contate para corrigir-mos!'
                        });
                        console.log(exception);
                    });
                }
            });
        },
        async updateData() {
            const data = {
                id: this.sidebarData.id,
                name: this.sidebarData.name,
                price: this.sidebarData.price,
                category: this.sidebarData.category || '',
                description: this.sidebarData.description || '',
                recurrence: this.sidebarData.recurrence
            }

            this.$validator.validateAll().then(async (response) => {
                if (!response) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Algo deu errado:',
                        text: 'Existem campos obrigatórios não preenchidos!'
                    });
                    return;
                }
                else {
                    await this.$store.dispatch("service/update", data)
                    .then((response) => {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Serviço atualizado com sucesso!'
                        });
                        this.closeSidebar();
                        this.fetch();
                    })
                    .catch((exception) => {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao atualizar o serviço!',
                            text: 'Erro ao atualizar o serviço, por favor nos contate para corrigir-mos!'
                        });
                        console.log(exception);
                    });
                }
            });
        },
        async deleteService() {
            await this.$store.dispatch("service/delete", this.deleteData.id)
            .then((response) => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Sucesso!',
                    text: 'Serviço deletado com sucesso!'
                });
                this.fetch();
            })
            .catch((exception) => {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Ocorreu um erro ao deletar o serviço!',
                    text: 'Erro ao deletar o serviço, por favor nos contate para corrigir-mos!'
                });
                console.log(exception);
            });
            this.closeDeleteModal();
        },
        async openDeleteModal(data) {
            this.deleteData = {
                id: data.id,
                name: data.name
            }
            this.deleteModalIsActive = true;
        },
        closeSidebar() {
            this.sidebarIsActive = false;
        },
        closeDeleteModal() {
            this.deleteModalIsActive = false;
        },
        hasDuplicate(arr) {
            const hasDuplicate = arr.reduce((acc, obj) => {
                if (acc.includes(obj.id)) {
                    return true;
                }
                acc.push(obj.id);
                return acc;
            }, []);

            if (typeof hasDuplicate === 'boolean') {
                return true;
            } 
            return false;
        },
        findDuplicateId(arr) {
            const seenIds = {};
            for (const { id } of arr) {
                if (seenIds[id]) {
                    return id;
                } else {
                    seenIds[id] = true;
                }
            }
            return null;
        },
        executeClickInElementById(id, arr) {
            arr.forEach((item) => {
                if (item.$attrs.id === id) {
                    item.$el.click();
                }
            });
        },
        removeObjectFromArrayById(id, arr) {
            var index = arr.findIndex(value => value.id === id);
            arr.splice(index, 1);
        },
        selectService(service) {
            service.selected = !service.selected
            
            if (service.selected) {
                    this.selectedServices.push(service);
            } 
            else {
                const index = this.selectedServices.findIndex(item => item.id === service.id);
                if (index !== -1) {
                    this.selectedServices.splice(index, 1);
                }
            }

            this.checkServicesAreSelected();
            this.$forceUpdate();
        },
        async selectAllServices() {
            if (this.allServicesAreSelected) {
                this.services.forEach(service => {
                    service.selected = false;
                    const index = this.selectedServices.findIndex(selectedService => selectedService.id === service.id);
                    if (index !== -1) {
                        this.selectedServices.splice(index, 1);
                    }
                });
            } else {
                await this.services.forEach(service => {
                    if (!service.selected) {
                        service.selected = true;
                        this.selectedServices.push(service);
                    }
                });
            }
            this.checkServicesAreSelected();
            this.$forceUpdate();
        },
        checkServicesAreSelected() {
            this.allServicesAreSelected = this.services.every(service => service.selected);
        },
    },
    computed: {
        totalPages() {
            return this.$store.state.service && this.$store.state.service.services.total_pages
                ? this.$store.state.service.services.total_pages
                : 0
        },
        queriedItems() {
            return this.$store.state.service && this.$store.state.service.services.total_items
                ? this.$store.state.service.services.total_items
                : 0
        },
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }

            return 0;
        },
        services() {
            return this.$store.state.service && this.$store.state.service.services
                ? this.$store.state.service.services.items : []
        },
        currentRoute() {
            return this.$route.name;
        },
        isServiceRoute() {
            return this.currentRoute === 'services';
        }
    },
    watch: {
        async 'page'() {
            await this.fetch();
        },
        'itemsPerPage'() {
            this.page = 1
            this.fetch()
        },
    },
    async mounted() {
        await this.fetch();
        this.isMounted = true;
    },
    beforeRouteLeave(to, from, next) {
        if (this.sidebarIsActive) {
            this.sidebarIsActive = false;
            setTimeout( ()=> {
            next();
            }, 2);
        } 
        else if (this.deleteModalIsActive) {
            this.deleteModalIsActive = false;
            setTimeout( ()=> {
            next();
            }, 2);
        }
        else {
            next();
        }
    },
}
</script>

<style scoped>
    ::v-deep .vs-sidebar {
        z-index: 52010 !important;
        width: 400px !important;
        max-width: 90vw !important;
    }
    ::v-deep .vs-sidebar--background {
        z-index: 52010 !important;
    }
</style>

<style lang="scss">
    .rootServices {
        * {
            margin: 0;
        }
        html {
            line-height: 1.5;
            letter-spacing: 0.02rem;
        }
        .con-tablex.vs-table--content {
            width: 101%; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 15px !important;
            padding: 0 1rem;
        }
        thead > tr {
            background-color: transparent !important;
        }
        .vs-table-text {
            text-transform: uppercase;
            font-size: 12px;
            margin-left: 15px;
        }
        input.input-search.vs-table--search-input {
            height: 45px;
        }
        tbody {
            > tr {
                height: 5em;
                box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05%);
                td.vs-table--td:last-of-type {
                    border-top-right-radius: 10px !important; 
                    border-bottom-right-radius: 10px !important;
                }
                td.vs-table--td:first-of-type {
                    border-top-left-radius: 10px !important; 
                    border-bottom-left-radius: 10px !important;
                }
            }
        }
    }
    .sidebar-services.add-new-data-sidebar.items-no-padding .vs-sidebar--items {
        overflow-y: auto !important;
    }
    .truncate-text {
        max-width: 200px;
        overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
    }
    .service-name {
        line-height: 20px;
    }
    .servicesInChat {
        #tableDataOfServicesInChat {
            .vs-con-tbody.vs-table--tbody {
                background-color: transparent !important;
                border: 0 !important;
            }
            table.vs-table.vs-table--tbody-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;
    
            }
            header {
                align-items: center;
                margin-left: 16px;
                margin-right: 16px;
                div > input {
                    border: solid 0.1px !important;
                    color: #726f6fb4;
                }
            }
            tbody {
                tr {
                    line-height: max(50px);
                }
                tr.tr-values.vs-table--tr.tr-table-state-null.is-selected.selected {
                    border-radius: 14px !important;
                }
                td {
                    padding: 0px;
                    border-style: solid;
                    border-color: #b6bebd6e;
                }
                td:first-of-type {
                    border-top-left-radius: 14px;
                    border-bottom-left-radius: 14px;
                    border-width: 1px 0px 1px 1px;
                }
                td:last-of-type {
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    border-width: 1px 1px 1px 0px;
                }
                td {
                    border-width: 1px 0px 1px 0px;
                }
            }
        }
    }
</style>